
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { RangeCriterionContent } from '@/jbi-shared/types/criterions.types';
import {
  isTruthy,
  isDifferentDeep
} from '@/jbi-shared/util/watcher.vue-decorator';

@Component({
  components: { ValidationProvider, ValidationObserver },
  data() {
    const r = (this as Vue & { range?: [number, number] }).range ?? [1, 10];
    return {
      start: Number(r[0]) || 1,
      end: Number(r[1]) || 10
    };
  }
})
export default class RangeCriterionInput extends Vue {
  @Prop()
  public range!: RangeCriterionContent['range'];

  declare start: number;
  declare end: number;

  @Watch('start')
  @Watch('end')
  public onChanged() {
    this.$emit('update:range', [this.start, this.end]);
  }

  @isTruthy
  @Watch('range')
  public onRangeUpdated() {
    const r = this.range ?? [1, 10];
    this.start = Number(r[0]);
    this.end = Number(r[1]);
  }
}
